<section class="aca-mig__card aca-mig__cardpad">
  <p class="aca-mig__notice" *ngIf="!editable">
    <mat-icon>cloud_off</mat-icon>
    <span>{{ 'DMS.MIGRATION.SETTINGS_UNAVAILABLE' | translate }}</span>
  </p>

  <fieldset [disabled]="!editable" style="border: 0; margin: 0; padding: 0">
    <h4 class="aca-mig__conncat">{{ 'DMS.MIGRATION.SET_GENERAL' | translate }}</h4>
    <div class="aca-mig__grid2">
      <label class="aca-mig__field">
        <span class="aca-mig__label">{{ 'DMS.MIGRATION.SET_BATCH' | translate }}</span>
        <input class="aca-mig__input" type="number" min="1" [(ngModel)]="settings.batchSize" />
      </label>
      <label class="aca-mig__field">
        <span class="aca-mig__label">{{ 'DMS.MIGRATION.SET_WORKERS' | translate }}</span>
        <input class="aca-mig__input" type="number" min="1" [(ngModel)]="settings.concurrentWorkers" />
      </label>
      <label class="aca-mig__field">
        <span class="aca-mig__label">{{ 'DMS.MIGRATION.SET_RETRIES' | translate }}</span>
        <input class="aca-mig__input" type="number" min="0" [(ngModel)]="settings.retryAttempts" />
      </label>
      <label class="aca-mig__field">
        <span class="aca-mig__label">{{ 'DMS.MIGRATION.SET_RETRY_DELAY' | translate }}</span>
        <input class="aca-mig__input" type="number" min="0" [(ngModel)]="settings.retryDelaySec" />
      </label>
      <label class="aca-mig__field">
        <span class="aca-mig__label">{{ 'DMS.MIGRATION.F_DUPPOLICY' | translate }}</span>
        <select class="aca-mig__select" [(ngModel)]="settings.duplicatePolicy">
          <option value="skip">{{ 'DMS.MIGRATION.DUP_SKIP' | translate }}</option>
          <option value="new">{{ 'DMS.MIGRATION.DUP_NEW' | translate }}</option>
          <option value="new-version">{{ 'DMS.MIGRATION.DUP_NEW_VERSION' | translate }}</option>
          <option value="review">{{ 'DMS.MIGRATION.DUP_REVIEW' | translate }}</option>
        </select>
      </label>
      <label class="aca-mig__field">
        <span class="aca-mig__label">{{ 'DMS.MIGRATION.SET_LOG_LEVEL' | translate }}</span>
        <select class="aca-mig__select" [(ngModel)]="settings.logLevel">
          <option value="minimal">{{ 'DMS.MIGRATION.LOG_MINIMAL' | translate }}</option>
          <option value="normal">{{ 'DMS.MIGRATION.LOG_NORMAL' | translate }}</option>
          <option value="verbose">{{ 'DMS.MIGRATION.LOG_VERBOSE' | translate }}</option>
        </select>
      </label>
    </div>

    <h4 class="aca-mig__conncat">{{ 'DMS.MIGRATION.SET_FIDELITY' | translate }}</h4>
    <div class="aca-mig__grid2">
      <label style="display: flex; gap: 8px; font-size: 12.5px; margin-bottom: 10px">
        <input type="checkbox" [(ngModel)]="settings.checksumVerification" />
        {{ 'DMS.MIGRATION.SET_CHECKSUM' | translate }}
      </label>
      <label style="display: flex; gap: 8px; font-size: 12.5px; margin-bottom: 10px">
        <input type="checkbox" [(ngModel)]="settings.preserveTimestamps" />
        {{ 'DMS.MIGRATION.SET_TIMESTAMPS' | translate }}
      </label>
      <label style="display: flex; gap: 8px; font-size: 12.5px; margin-bottom: 10px">
        <input type="checkbox" [(ngModel)]="settings.preserveVersions" />
        {{ 'DMS.MIGRATION.SET_VERSIONS' | translate }}
      </label>
      <label style="display: flex; gap: 8px; font-size: 12.5px; margin-bottom: 10px">
        <input type="checkbox" [(ngModel)]="settings.preservePermissions" />
        {{ 'DMS.MIGRATION.SET_PERMISSIONS' | translate }}
      </label>
    </div>

    <h4 class="aca-mig__conncat">{{ 'DMS.MIGRATION.SET_NOTIFY' | translate }}</h4>
    <div class="aca-mig__grid2">
      <label class="aca-mig__field">
        <span class="aca-mig__label">{{ 'DMS.MIGRATION.SET_NOTIFY_EMAIL' | translate }}</span>
        <input class="aca-mig__input" type="text" [(ngModel)]="settings.notifyEmail" [placeholder]="'DMS.MIGRATION.PH_NOTIFY_EMAIL' | translate" />
        <span class="aca-mig__hint">{{ 'DMS.MIGRATION.SET_NOTIFY_EMAIL_HINT' | translate }}</span>
      </label>
      <label style="display: flex; gap: 8px; font-size: 12.5px; margin-bottom: 10px">
        <input type="checkbox" [(ngModel)]="settings.notifyRunOwner" />
        {{ 'DMS.MIGRATION.SET_NOTIFY_OWNER' | translate }}
      </label>
    </div>

    <p class="aca-mig__hint" style="margin-top: 12px">{{ 'DMS.MIGRATION.SETT_ENGINE_NOTE' | translate }}</p>

    <div style="margin-top: 8px">
      <button type="button" class="aca-mig__btn aca-mig__btn--primary" [disabled]="!editable || busy()" (click)="save()">
        {{ 'DMS.MIGRATION.SAVE' | translate }}
      </button>
    </div>
  </fieldset>
</section>
